<div class="card-body p-3">

    <div class="row">
        <div class="col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
            </app-benef-info>
        </div>
        <div class="col col-md-9">
            <div class="lab-panel" style="position:relative;">

                <!-- ── Loader overlay ── -->
                <div *ngIf="isLoading" class="lab-loader-overlay">
                    <div class="lab-spinner"></div>
                </div>

                <!-- ── Table 1 : Prescriptions actives ── -->
                <div class="lab-section">
                    <div class="lab-section-header">
                        <span class="lab-section-title">Prescriptions actives</span>
                        <button class="lab-refresh-btn" (click)="getItemsPrescriptionActe()" title="Actualiser">
                            <i class="fa fa-redo-alt"></i>
                        </button>
                    </div>
                    <div class="table-wrap">
                        <table class="lab-table">
                            <thead>
                                <tr>
                                    <th class="col-num">#</th>
                                    <th>Acte</th>
                                    <th class="col-opt">Option</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Skeleton -->
                                <ng-container *ngIf="!itemBeneficiare?.id">
                                    <tr *ngFor="let s of [1,2,3]" class="skel-row">
                                        <td><span class="skel-cell" style="width:20px"></span></td>
                                        <td><span class="skel-cell" style="width:70%"></span></td>
                                        <td><span class="skel-cell" style="width:60px"></span></td>
                                    </tr>
                                </ng-container>
                                <!-- Données -->
                                <ng-container *ngIf="itemBeneficiare?.id">
                                    <tr *ngFor="let item of itemsPrescription; let i = index" [ngClass]="{
                                            'row-rejected': item.is_entente_prealable && item.is_traite,
                                            'row-orange':   item.is_entente_prealable && !item.is_traite,
                                            'row-red':      item.is_exclu,
                                            'row-green':    !item.is_exclu && !item.is_entente_prealable && !item.is_executed,
                                            'row-executed': item.is_executed,
                                            'medoc-replaced': item.is_replaced,
                                            'medoc-replacer': item.is_replacer,
                                            'disabled-row': item.is_eligible === false
                                        }">
                                        <td class="col-num">{{ i + 1 }}</td>
                                        <td>{{ item.acte_libelle }}<span *ngIf="item.is_eligible === false" class="badge bg-secondary ms-1" style="font-size:0.65rem;cursor:help" title="Acte prescrit par référence : ce prestataire n'est pas autorisé à l'exécuter directement">Référé</span></td>
                                        <td class="col-opt">
                                            <button *ngIf="canAdd(item) && item.is_eligible !== false" (click)="addItemToList(item)"
                                                class="btn-lab-add">Ajouter</button>
                                            <span class="tag-blink tag-red" *ngIf="item.is_exclu">Non garanti</span>
                                            <span class="tag-blink tag-orange"
                                                *ngIf="item.is_entente_prealable && !item.is_traite">En attente préalable</span>
                                            <span class="tag-blink tag-orange"
                                                *ngIf="item.is_entente_prealable && item.is_traite">Rejeté
                                                ({{item.commentaire_validateur}})</span>
                                            <span class="tag-executed" *ngIf="item.is_executed">Déjà exécuté</span>
                                            <button class="btn-lab-chat ms-1" (click)="openChatDialog(item)"
                                                title="Discuter">
                                                <i class="fa fa-comments"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!itemsPrescription?.length" class="empty-row">
                                        <td colspan="3">Aucune prescription active</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ── Table 2 : Actes à exécuter ── -->
                <div class="lab-section">
                    <div class="lab-section-header">
                        <span class="lab-section-title">Actes à exécuter</span>
                    </div>
                    <div class="table-wrap">
                        <table class="lab-table">
                            <thead>
                                <tr>
                                    <th class="col-num">#</th>
                                    <th>Acte</th>
                                    <th class="col-num text-end">Montant</th>
                                    <th class="col-num text-end">Part patient</th>
                                    <th class="col-num text-end">Part assurance</th>
                                    <th class="col-opt">Option</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Skeleton -->
                                <ng-container *ngIf="!itemBeneficiare?.id">
                                    <tr *ngFor="let s of [1,2]" class="skel-row">
                                        <td><span class="skel-cell" style="width:20px"></span></td>
                                        <td><span class="skel-cell" style="width:60%"></span></td>
                                        <td><span class="skel-cell" style="width:40px;margin-left:auto"></span></td>
                                        <td><span class="skel-cell" style="width:40px;margin-left:auto"></span></td>
                                        <td><span class="skel-cell" style="width:40px;margin-left:auto"></span></td>
                                        <td><span class="skel-cell" style="width:50px"></span></td>
                                    </tr>
                                </ng-container>
                                <!-- Données -->
                                <ng-container *ngIf="itemBeneficiare?.id">
                                    <tr *ngFor="let item of itemsPrescriptionAservir; let i = index">
                                        <td class="col-num">{{ i + 1 }}</td>
                                        <td>{{ item.acte_libelle }}</td>
                                        <td class="text-end">{{ item.montant | IntegerFormatPipe }}</td>
                                        <td class="text-end" [class.val-struck]="itemToSave.montant_depassement > 0">
                                            <a *ngIf="item.message_explicatif" (click)="showMessageExplicatif(item)"
                                                class="link-blue">{{ (item.part_patient||0) | IntegerFormatPipe }}</a>
                                            <span *ngIf="!item.message_explicatif">{{ (item.part_patient||0) | IntegerFormatPipe }}</span>
                                        </td>
                                        <td class="text-end" [class.val-struck]="itemToSave.montant_depassement > 0">
                                            {{ (item.part_assurance||0) | IntegerFormatPipe }}
                                        </td>
                                        <td class="col-opt">
                                            <button (click)="removeMedicamentFromList(item)"
                                                class="btn-lab-remove">Retirer</button>
                                        </td>
                                    </tr>
                                    <!-- Totaux -->
                                    <tr class="totals-row" *ngIf="itemsPrescriptionAservir?.length">
                                        <td colspan="2"></td>
                                        <td class="text-end">{{ getTotal() | IntegerFormatPipe }}</td>
                                        <td class="text-end" [class.val-struck]="itemToSave.montant_depassement > 0">
                                            {{ getTotalPartPatient() | IntegerFormatPipe }}</td>
                                        <td class="text-end" [class.val-struck]="itemToSave.montant_depassement > 0">
                                            {{ getTotalPartAssurance() | IntegerFormatPipe }}</td>
                                        <td></td>
                                    </tr>
                                    <tr *ngIf="!itemsPrescriptionAservir?.length" class="empty-row">
                                        <td colspan="6">Aucun acte à exécuter</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- ── Alerte dépassement ── -->
                <div *ngIf="itemToSave.montant_depassement && itemToSave.montant_depassement > 0"
                    class="depassement-alert">
                    <div class="dep-title">⚠️ {{ itemToSave.message_depassement }}</div>
                    <div class="dep-body">
                        <span>Dépassement : <strong class="text-danger">{{ itemToSave.montant_depassement |
                                IntegerFormatPipe }} FCFA</strong></span>
                        <span>Part assurance : <strong class="text-success">{{ getTotalPartAssurance() -
                                itemToSave.montant_depassement | IntegerFormatPipe }} FCFA</strong></span>
                        <span>Part patient : <strong class="text-danger">{{ getTotalPartPatient() +
                                itemToSave.montant_depassement | IntegerFormatPipe }} FCFA</strong></span>
                    </div>
                    <button (click)="confirmSaveItem(itemToSave)" class="btn-lab-confirm">✅ Continuer</button>
                </div>

                <!-- ── Soumettre ── -->
                <div class="lab-footer">
                    <button (click)="onActeDeepSeekWithSubmit()" [disabled]="!itemsPrescriptionAservir?.length"
                        class="btn-lab-submit">
                        Soumettre
                    </button>
                </div>

            </div>
        </div>
    </div>

</div>
